export default __webpack_public_path__ + "static/media/slide2.de547066.jpg";